package com.arena_web.data.dto

import kotlinx.serialization.Serializable

/** One address autocomplete suggestion — backend GeoRoute (Google Places proxy). */
@Serializable
data class AddressSuggestionDto(
    val placeId: String,
    /** Main line, e.g. "Khreshchatyk Street, 22". */
    val title: String,
    /** Secondary line, e.g. "Kyiv, Ukraine". */
    val subtitle: String? = null,
)

/** Resolved place — coordinates + the address parts an event/club stores. */
@Serializable
data class PlaceAddressDto(
    val latitude: Double,
    val longitude: Double,
    val street: String? = null,
    val houseNumber: String? = null,
    val city: String? = null,
    val country: String? = null,
    val formattedAddress: String? = null,
)
